import React, { Component } from 'react';
import { GeckoAvatar } from 'ui';
import GeckoLocation from 'services/gecko-location';
import './index.scss';
import GeckoPermissions from 'services/gecko-permissions';

const botPlaceholder = `${process.env.PUBLIC_URL}/bot-placeholder.png`;

class ActiveBotHead extends Component {
  goToSettings() {
    return GeckoLocation.goTo(`/bots/${this.props.bot.id}/settings`);
  }

  render() {
    // renders bot fields as blank until active bot found
    let botName = this.props.bot
      ? this.props.bot.name
      : this.props.botId === 'new'
      ? 'Create new bot'
      : '';
    let botAvatar = this.props.bot
      ? this.props.bot.user.additional.profile_picture_url
      : this.props.botId === 'new'
      ? botPlaceholder
      : botPlaceholder;
    let loadClass = this.props.bot || this.props.botId === 'new' ? 'load' : '';

    return (
      <div className="ActiveBotHead">
        {!GeckoPermissions.memberOf('agent') ? (
          <div
            className="ActiveBotHead-Settings-Cog"
            onClick={this.goToSettings.bind(this)}
            role="button"
            aria-label="Open Bot Settings"
          >
            <i className="far fa-spin-hover fa-cog" />
            <div className="text">Bot settings</div>
          </div>
        ) : null}
        <div className="bot-header">
          <div className="overlay"></div>
        </div>

        <div className={`bot-header-container ${loadClass}`}>
          <div className={`row justify-content-center`}>
            <GeckoAvatar
              name={botName}
              bgImage={botAvatar ? botAvatar : botPlaceholder}
            />
          </div>
          <div
            role="heading"
            className={`row bot-title justify-content-center`}
          >
            {botName}
          </div>
        </div>
      </div>
    );
  }
}

export default ActiveBotHead;
